export default __webpack_public_path__ + "static/media/pastaDash.01e2bbf1.svg";